interface ServiceConfig {
    API_URL: string;
    IMAGE_URL: string;
}

// Point at a local backend with REACT_APP_API_URL in .env (e.g. http://localhost:5001).
// Falls back to the deployed dev API, so builds without a .env behave exactly as before.
var service: ServiceConfig = {
    API_URL: process.env.REACT_APP_API_URL || 'https://dev-api.instaacard.com',
    IMAGE_URL: process.env.REACT_APP_IMAGE_URL || 'https://dev-api.instaacard.com/'
};

export default service;
